<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import AdditionalHelp from "./../Components/AdditionalHelp.svelte";
  import SideCart from "./Partials/SideCart.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import HelpRin from "./Partials/HelpRIN.svelte";
  import RenewalFaq from "../FAQ/RenewalFaq.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia, router, useForm } from "@inertiajs/svelte";
  import { formatGeneral } from "cleave-zen";
  import { fade, slide } from "svelte/transition";

  let showHelpRIN = false;

  const form = useForm("searchForm", {
    combined: null,
    vin: null,
    plate_number: null,
    zip: null,
    search_type: null,
  });

  function handleSubmit() {
    $form.clearErrors();
    $form.post(route("renewal.search.lookup"));
  }

  function inputRIN(e) {
    $form.combined = formatGeneral(e.target.value, {
      blocks: [4, 4, 4],
      delimiter: "-",
      numericOnly: true,
    });
  }
  function inputVIN(e) {
    $form.vin = formatGeneral(e.target.value, {
      blocks: [4],
      numericOnly: true,
    });
  }

  function toggleRinHelp() {
    showHelpRIN = !showHelpRIN;
  }

  let DebugComponent;
  if (import.meta.env.VITE_MOCK == "true") {
    import("../../Debug/Debug.svelte").then((module) => {
      DebugComponent = module.default;
    });
  }
</script>

{#if import.meta.env.VITE_MOCK == "true"}
  {#if DebugComponent}
    <svelte:component
      this={DebugComponent}
      formData={form}
      include="RenewalSearch"
    />
  {/if}
{/if}

<PageHead>
  <svelte:fragment slot="title">Registration Renewal</svelte:fragment>
  <svelte:fragment slot="tagline"
    >To renew your registration, first search for your vehicle.</svelte:fragment
  >
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="search"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-12 col-lg-8">
    <div class="card">
      <div class="card-body text-center">
        <p>
          Please enter the following information to retrieve your vehicle
          record.
        </p>

        <Alerts {form} />
        <form on:submit|preventDefault={handleSubmit}>
          <div id="lookupForm">
            <div class="accordion-group">
              <div
                class:show={$form.search_type !== "vin"}
                class="collapse row align-items-center justify-content-center"
                id="rin"
                data-bs-parent="#lookupForm"
                transition:fade={{ duration: 300 }}
              >
                <div class="col-12 col-md-8">
                  <div class="form-floating input-group">
                    <input
                      class:is-invalid={$form.errors.combined}
                      class="form-control"
                      placeholder="0000-0000-0000"
                      id="renewalId"
                      name="combined"
                      bind:value={$form.combined}
                      on:input={inputRIN}
                    />
                    <label for="renewalId">Renewal ID Number</label>
                    <button
                      class="btn btn-outline-secondary"
                      type="button"
                      on:click={toggleRinHelp}
                      title="Where is this?"
                    >
                      <i class="bi bi-question-lg"></i>
                    </button>
                    {#if $form.errors.combined}
                      <div class="invalid-feedback">
                        {$form.errors.combined}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-12 text-center mt-2">
                  <a
                    class="btn btn-outline-secondary"
                    use:inertia
                    href={window.route("home")}
                    id="button-addon2">Cancel</a
                  >
                  <button
                    class="btn btn-success"
                    type="submit"
                    id="button-addon2"
                    on:click|once={($form.search_type = "rin")}
                    name="search_type"
                    disabled={$form.processing}>Submit</button
                  >
                </div>
                <div class="col-12">
                  <hr class="mb-3 border-secondary-subtle w-75 mx-auto" />
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    data-bs-toggle="collapse"
                    data-bs-target="#vin"
                    data-bs-parent="#lookupForm"
                    disabled={$form.processing}
                    on:click={($form.search_type = "vin")}
                    >What if I don't have my renewal reminder?</button
                  >
                </div>
              </div>
              <div
                class:show={$form.search_type === "vin"}
                class="collapse row align-items-center justify-content-center"
                id="vin"
                data-bs-parent="#lookupForm"
                transition:fade={{ duration: 300 }}
              >
                <div class="col-12 col-md-8">
                  <div class="form-floating">
                    <input
                      class:is-invalid={$form.errors.vin}
                      class="form-control"
                      placeholder="0000-0000-0000"
                      id="vinId"
                      minlength="4"
                      name="vin"
                      bind:value={$form.vin}
                      on:input={inputVIN}
                    />
                    <label for="renewalId"
                      >Last 4 digits of Vehicle ID Number (VIN)</label
                    >
                    {#if $form.errors.vin}
                      <div class="invalid-feedback">
                        {$form.errors.vin}
                      </div>
                    {/if}
                  </div>
                  <div class="form-floating mt-2">
                    <input
                      class:is-invalid={$form.errors.plate_number}
                      class="form-control input-license-plate"
                      maxlength="7"
                      placeholder="000-000"
                      id="licensePlateNumber"
                      name="plate_number"
                      bind:value={$form.plate_number}
                    />
                    <label for="licensePlateNumber">License Plate Number</label>
                    {#if $form.errors.plate_number}
                      <div class="invalid-feedback">
                        {$form.errors.plate_number}
                      </div>
                    {/if}
                  </div>
                  <div class="form-floating mt-2">
                    <input
                      class:is-invalid={$form.errors.zip}
                      class="form-control input-zip"
                      maxlength="5"
                      minlength="5"
                      placeholder="00000"
                      id="zipCode"
                      name="zip"
                      bind:value={$form.zip}
                    />
                    <label for="zipCode">Zip Code</label>
                    {#if $form.errors.zip}
                      <div class="invalid-feedback">
                        {$form.errors.zip}
                      </div>
                    {/if}
                  </div>
                </div>
                <div class="col-12 text-center mt-2">
                  <button
                    class="btn btn-outline-secondary"
                    use:inertia={{
                      href: window.route("home"),
                      preserveState: true,
                    }}
                    id="button-addon2">Cancel</button
                  >
                  <button
                    class="btn btn-success"
                    type="submit"
                    id="button-addon2"
                    value="vin"
                    name="search_type"
                    disabled={$form.processing}>Submit</button
                  >
                </div>
                <div class="col-12">
                  <hr class="mb-3 border-secondary-subtle w-75 mx-auto" />
                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    data-bs-toggle="collapse"
                    data-bs-target="#rin"
                    data-bs-parent="#lookupForm"
                    disabled={$form.processing}
                    on:click={($form.search_type = "rin")}
                  >
                    Or search by your Renewal ID Number
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-4 mt-4 mt-lg-0">
    <SideCart />
    <RenewalFaq />
    <AdditionalHelp />
  </div>
</div>

<HelpRin bind:showHelpRIN />
